import React, { useCallback } from 'react';
import VoxelRadio from '../../../../voxel/Forms/VoxelRadio';
import VoxelMenuItemContainer from '../../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelText from '../../../../voxel/Text/VoxelText';
import HeadCell from '../../Shared/HeadCell';
import HeadCellStandardOptions from '../../Shared/HeadCellStandardOptions';
import { KeywordTableState } from '../logic/useKeywordTableState';
import { HeadCellImplementationProps } from './models';

export interface HeadCellKeywordProps extends HeadCellImplementationProps {
  keywordTableState: KeywordTableState;
}

const HeadCellKeyword: React.FC<HeadCellKeywordProps> = ({
  keywordTableState,
  basicConfig,
  basicState,
}) => {
  const { setSortingState, sortingState, filterState, setFilterState } = keywordTableState;

  // Radio button logic
  const handleRadioChange = useCallback((value: string) => {
    setFilterState((prev) => {
      if (+value === 1) {
        return { ...prev, wordCountExact: 1, wordCountMin: null };
      }
      if (+value === 2) {
        return { ...prev, wordCountExact: 2, wordCountMin: null };
      }
      if (+value === 3) {
        return { ...prev, wordCountExact: 3, wordCountMin: null };
      }
      if (+value === 3.5) {
        return { ...prev, wordCountExact: null, wordCountMin: 3 };
      }
      if (+value === 4.5) {
        return { ...prev, wordCountExact: null, wordCountMin: 4 };
      }
      return { ...prev, wordCountExact: null, wordCountMin: null };
    });
  }, []);

  // Filter logic
  const radioGroupValue = filterState.wordCountMin
    ? filterState.wordCountMin + 0.5
    : filterState.wordCountExact ?? 0;
  const hasFilter = !!filterState.keyword?.searchTerm?.length || radioGroupValue > 0;

  return (
    <HeadCell
      basicConfig={basicConfig}
      basicState={basicState}
      align={'left'}
      hasFilter={hasFilter}
    >
      <div className="w-60">
        <VoxelMenuItemContainer size="md">
          <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />

          <div className="flex flex-col gap-2 px-4 pt-2 pb-4 w-60">
            <VoxelText variant="form-caption">Word count filter</VoxelText>
            <VoxelRadio
              value={0}
              title={'All keywords'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
            <VoxelRadio
              value={1}
              title={'1'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
            <VoxelRadio
              value={2}
              title={'2'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
            <VoxelRadio
              value={3}
              title={'3'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
            <VoxelRadio
              value={3.5}
              title={'3+'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
            <VoxelRadio
              value={4.5}
              title={'4+'}
              selectedOption={radioGroupValue}
              setSelectedOption={handleRadioChange}
            />
          </div>
        </VoxelMenuItemContainer>
      </div>
    </HeadCell>
  );
};

export default HeadCellKeyword;
